import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var AppButtonsDesktop = /*#__PURE__*/memo(function (_ref) {
  var appLink = _ref.appLink,
    appLinkIcon = _ref.appLinkIcon,
    appQRCodeLinkIconWithText = _ref.appQRCodeLinkIconWithText,
    appQRCodeLinkIcon = _ref.appQRCodeLinkIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('app-buttons-desktop')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('app-buttons-desktop__app')
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0438\u043B\u0430\u0439\u043D",
    className: cn('app-link'),
    href: appLink
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    loading: "lazy",
    src: appLinkIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: cn('app-buttons-desktop__app')
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 1023px)",
    srcSet: appQRCodeLinkIconWithText
  }), /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 1440px)",
    srcSet: appQRCodeLinkIcon
  }), /*#__PURE__*/React.createElement("img", {
    alt: "QR-\u0138\u043E\u0434 \u0434\u043B\u044F \u0441\u0138\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    loading: "lazy",
    src: appQRCodeLinkIconWithText
  }))));
});